export const ChickenSvg = (props) => {
  return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        fill="#000000"
        {...props}
      >
        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
          <path
            d="M940.1 335.3c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-77.2v106.5c0 166.2-115.8 305.9-270.9 342.7v81.8h27.3c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4H415.2c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h57.2v-74.4C308.5 814.8 178 684.2 160.5 520.3h-8.2c-24.4 0-45.3-19.1-48.5-44.3-0.1-0.8-0.2-1.6-0.2-2.4V412c-10.8-5.1-20.9-11.4-30.2-19-6.9-5.6-10.9-14-10.9-22.9 0-8.8 3.9-17.1 10.7-22.8 24.7-20.4 55.3-32 87.2-33.2 3.8-24.4 13.5-47.2 28.3-66.9-17.2-11.6-28.6-31.4-28.6-53.7 0-35.7 29-64.7 64.7-64.7 10.1-30.1 38.6-51.9 72-51.9 41.8 0 75.8 34 75.8 75.8 0 16-5.1 31-13.8 43.4 58 20.7 99.7 76.2 99.7 141.3v103.2h243c66.5 0 120.6-38 120.7-84.8v-97.6c0-11.3 9.1-20.4 20.4-20.4 11.3 0 20.4 9.1 20.4 20.4v48.3l34.1-34.1c8-7.9 20.9-7.9 28.8 0 8 8 8 20.9 0 28.8l-34.1 34.1h48.3z"
            fill="#663333"
          />
          <path
            d="M822.2 439.3v43.2c0 171.7-139.7 311.5-311.4 311.5-169 0-311.5-140.1-311.5-311.5v-1.1h38.3c11.3 0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4h-38.3v-23.1c16.2-10.5 24.7-28.9 24.8-47.1 0.1-18.1-8-36.5-23.9-47.2 3-23.9 13.8-45.9 31.1-63.2 20.6-20.6 48.1-32 77.2-32 60.2 0 109.3 49 109.3 109.2v103.2h-82.1c-11.3 0-20.4 9.1-20.4 20.4 0 11.3 9.1 20.4 20.4 20.4h365.8c42.1 0 81.8-12.4 111.9-34.9 3.1-2.2 6-4.5 8.8-7z"
            fill="#c5965c"
          />
          <path
            d="M706.5 521.2c17 39.4-1.1 85.2-40.5 102.3-9.8 4.3-20.4 6.4-30.9 6.4-2.5 0-5-0.1-7.5-0.4-16 56.8-68.3 98.4-129.9 98.4-0.7 0-134 1.9-134-137.3 0-11.3 9.5-20.3 20.7-20.1 11.3 0.2 20.2 9.4 20.1 20.7-0.8 51.9 40.8 94.9 92.7 95.7 0.5 0 0 0.2 0.5 0.2 51.3 0 93.4-41.3 94.2-92.7 0.2-11.3 9.5-20.2 20.7-20.1 9.2 0.2 16.8 6.3 19.2 14.7 6.1 0.5 12.2-0.4 18-2.9 18.8-8.1 27.4-29.9 19.3-48.7-4.5-10.3 0.3-22.3 10.6-26.8 10.4-4.5 22.4 0.3 26.8 10.6z"
            fill="#663333"
          />
          <path
            d="M331.9 152.7c0 17.3-12.9 32.2-29.9 34.7-0.2 0-41.1-1.1-82.7 29.4-10.5-2.5-18.4-12-18.4-23.3 0-13.2 10.7-24 24-24 3.1 0 6.1 0.6 8.9 1.7 6.3 2.5 13.4 1.8 19-2s9-10 9-16.8c0.1-19.2 15.9-34.8 35.1-34.8 19.2 0 35 15.7 35 35.1z"
            fill="#FE6865"
          />
          <path
            d="M283.2 291.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4z"
            fill="#663333"
          />
          <path
            d="M168.5 354.7c13.8 0.3 14.8 12 14.8 15.5-0.1 13.6-10.4 15.2-14.9 15.2-20.3 0.2-40-5.2-57.1-15.5 17.1-10.3 37-15.7 57.2-15.2z"
            fill="#FFCC66"
          />
          <path
            d="M158.5 426v57.6h-6.2c-5.6 0-10.8-4.9-12-11.4v-48.4c6 1.1 12.1 1.8 18.2 2.2z"
            fill="#FE6865"
          />
          <path
            d="M551.3 907.1v-74.7c-12.5 1.4-25.3 2.2-38.1 2.3V907h38.1z"
            fill="#FFFFFF"
          />
        </g>
      </svg>
  );
};
